<div [class.last-row]="last" [class.modal]="formConfig.step === 'Modal'" [class.saved]="messageID"
     class="table-content">
  <form *ngIf="!messageID" [id]="newForm.id" [name]="newForm.id"></form>
  <form *ngIf="messageID" [id]="editForm.id" [name]="editForm.id"></form>
</div>
